module.exports = __webpack_public_path__ + "img/comanda_trimisa.a6b0c65d.svg";